import React, { useState, useEffect, Fragment } from "react";
import FormValidators from "../FormValidators/index";
import NonHostedLinks from "./NonHostedLinks";
import { Field, reduxForm } from "redux-form";
import { UpwardReduxInput } from "../ui";
import axios from "axios";

const EmailForm = (props) => {
  const [count, setCount] = useState(0);
  const [inputChanged, setInputChanged] = useState(false);

  const flowVal = props.sessionId % 2 === 0 ? 1 : 0;

  useEffect(() => {
    if(count === 1 && inputChanged === false){
      document.getElementById("email").focus();
      setCount(count + 1);
    }else{
      document.getElementById("email").focus();
    }
  },[]);

  var getHeight = function(el) {
    var el_style = window.getComputedStyle(el),
        el_display = el_style.display,
        el_position = el_style.position,
        el_visibility = el_style.visibility,
        el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),

        wanted_height = 0;

    if(el_display !== 'none' && el_max_height !== '0') {
      return el.offsetHeight;
    }

    el.style.position = 'absolute';
    el.style.visibility = 'hidden';
    el.style.display = 'block';

    wanted_height     = el.offsetHeight;

    // reverting to the original values
    el.style.display = el_display;
    el.style.position = el_position;
    el.style.visibility = el_visibility;

    return wanted_height;
},


toggleSlide = function(el) {
    var el_max_height = 0;

    if(el.getAttribute('data-max-height')) {
        if(el.style.maxHeight.replace('px', '').replace('%', '') === '0') {
            el.style.maxHeight = el.getAttribute('data-max-height');
        } else {
            el.style.maxHeight = el.getAttribute('data-max-height');
        }
    } else {
        el_max_height = getHeight(el) + 'px';
        el.style['transition'] = 'max-height 0.5s ease-in-out';
        el.style.overflowY = 'hidden';
        el.style.maxHeight = '0';
        el.setAttribute('data-max-height', el_max_height);
        el.style.display = 'block';

        setTimeout(function() {
            el.style.maxHeight = el_max_height;
        }, 10);
    }
};

  let resumeCB = document.getElementsByClassName('resumeOptinRadio');
  let optinsQuery;
  if(resumeCB.length > 0){
    let confirmations = resumeCB.checked.map(function(i,item){ return item.value}).get().filter(function(item){ return item !== "" }).join(",");
    optinsQuery = {
      optin_advertisers : confirmations,
      _ : + new Date()
    }
  } else {
    optinsQuery = {
      regOid : 3944,
      optin_advertisers : "",
      _ : + new Date()
    }
  }

  const optinsQueryString = Object.keys(optinsQuery).map(key => key + '=' + optinsQuery[key]).join('&');

  const handleSubmit = e => {

    //window.dataLayer.push({'uwCID': props.cid});
    props.showLoad();

    axios.all([
      axios.get(process.env['REACT_APP_API_URL'] + '/search/internalPost2.fsn?OID=3002&new_flow=' + flowVal +"&" + props.queryString),
    ])
    .then(data => {
      if(inputChanged || props.duplicateUser === undefined || props.duplicateUser === false){
        axios.all([
          axios.get(process.env['REACT_APP_API_URL'] + '/upward/accountSignup.jsp?noeml=true&OID=3002&' + props.queryString)
        ])
        .then(data => {
          window.newrelic.addPageAction('registration', {registration: 'success', file: 'EmailForm.js'});
          props.setLoggedIn(true);
          axios.get(process.env['REACT_APP_API_URL'] + "/upward/employee/update_profile.jsp?" + props.queryString)
          if(props.duplicateUser === undefined || props.duplicateUser === false){
            let iframe4 = document.createElement('iframe');
            iframe4.src = process.env['REACT_APP_API_URL'] + '/search/getPixel.fsn?cid='+props.cid;
            iframe4.style.height = 0;
            iframe4.style.width = 0;
            document.body.appendChild(iframe4);
          }
        });
      }
      if(props.termsText !== ""){
        //window.getAvailableOptins();
        axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
      } 
      props.updateEmail(props.email);
      if(props.jobPage !== undefined && props.jobPage === 8 && props.duplicateUser !== undefined && props.duplicateUser === true){
        props.setShowRegOverlay(false);
        //window.offerGo();
      }else{
        props.onFormSubmit('number');
      } 
      props.onFormSubmit('number');
      props.hideLoad();
    }, (error) => {
      console.log('ERROR: '+error);
      window.Rollbar.error("email form error", error);
      props.hideLoad();
    });

  }

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit(handleSubmit)} autoComplete="off">
                <div className="form-group">
                    <Field component={UpwardReduxInput}
                      validate={[FormValidators.required,FormValidators.email]}
                      type="email"
                      name="email"
                      id="email"
                      autoComplete="off"
                      controlledValue={props.email}
                      placeholder="name@domain.com"
                      onChange={e => {props.updateEmail(e.target.value); setInputChanged(true)}}
                      onClick={() => {setCount(count + 2)}}/>
                    <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
                    <div className="text-center"><button type="submit" className="btn btnSmall fullwidth btn-block" style={{"width":"180px"}}>Continue</button></div>
                </div>
                {(((props.hostedType.toLowerCase() !== "hosted" && props.hostedType.toLowerCase() !== "hosted_plus") ||  (props.hostedType.toLowerCase() === "")) && (props.qs.skip === "yes" || props.qs.skip === "x"))
                &&
                <NonHostedLinks {...props}/>
                }
            </form>
        </Fragment>
    )

}

export default reduxForm({
  form: 'EmailForm',
})(EmailForm);
